// Keep SSR seeding and browser mutation code on the same Nuxt state entry.
export const CSRF_TOKEN_STATE_KEY = 'csrf-token'
